export default {
      id: "customers-menu-usage",
      viewBox: "0 0 35 35",
      url: "/dist/svg/" + "sprite.svg#customers-menu-usage",
      toString: function () {
        return this.url;
      }
    }